module.exports = __webpack_public_path__ + "static/media/mas prevencion.c3878514.png";